import { Typography } from "@octopus-energy/coral/atoms"

export function getDefaultStringResolver(string: string) {
    return <Typography>{string}</Typography>
}
